
(function(){
  function initProductExtras(){
    var button=document.getElementById('mpPdViewSize');
    if(button&&!button.dataset.ready){
      button.dataset.ready='1';
      button.addEventListener('click',function(){
        var gallery=document.getElementById('mpCarousel');
        var thumbnails=document.querySelectorAll('#shop .thumb');
        var target=Array.from(thumbnails).find(function(x){return /size|guide|chart/i.test((x.querySelector('img')||{}).alt||'')})||thumbnails[3];
        if(target)target.click();
        if(gallery)gallery.scrollIntoView({behavior:'smooth',block:'center'});
      });
    }
    var story=document.getElementById('mpPdStoryImg');
    if(story&&!story.src){
      var thumbs=document.querySelectorAll('#shop .thumb img');
      var pic=thumbs[1]||document.getElementById('mainProductImage');
      if(pic)story.src=pic.src;
    }
  }
  document.addEventListener('DOMContentLoaded',initProductExtras);
  window.addEventListener('hashchange',initProductExtras);
})();
